import { render, staticRenderFns } from "./NovoTenant.vue?vue&type=template&id=965cac28&"
import script from "./NovoTenant.vue?vue&type=script&lang=js&"
export * from "./NovoTenant.vue?vue&type=script&lang=js&"
import style0 from "./NovoTenant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports